import { render, staticRenderFns } from "./MainSettings.vue?vue&type=template&id=4150944e&scoped=true"
import script from "./MainSettings.vue?vue&type=script&lang=js"
export * from "./MainSettings.vue?vue&type=script&lang=js"
import style0 from "./MainSettings.vue?vue&type=style&index=0&id=4150944e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4150944e",
  null
  
)

export default component.exports